import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectCustodialPlanMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_PFIX_CUSTODIAL_PLAN_MESSAGE);
        this.Id = 0;
        this.Name = null;
        this.Data = [];
    }
}
